import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Accordion,
  InputGroup,
  Spinner,
} from 'react-bootstrap';
import Verified from 'assets/images/verified.gif';

import {
  Formik,
  Field,
  Form as FormikForm,
  FormikHelpers,
  ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DashboardHttp from '../services/profile.service';
import OtpWithTimer from 'shared/common/otpWithTimer/otpWithTimer';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import OtpModal from 'shared/common/modal/otp_modal';
import Alert from 'shared/common/alert';

// import UserHttp from '../services/profile.service';
interface FormValues {
  first_name: any;
  last_name: any;
  age: any;
  relation: any;
  mobile_no: any;
  email: any;
}
const Nomination = ({
  account,
  customerId,
  customer,
  setCustomer,
  user,
}: any) => {
  const [nominees, setNominees] = useState([]);
  const [isAddNominee, setIsAddNominee] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [val, setVal] = useState(false);
  const [otpValue, setOtpValue] = useState<string>('');
  // const [session, setSession] = useState(null);
  // const [errorModal, setErrorModal] = useState<any>({});
  // const [isOtpLogin, setIsOtpLogin] = useState<boolean>(false);
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isMobileVerify, setIsMobileVerify] = useState<boolean>(false);
  const [isMobileDisable, setIsMobileDisable] = useState<boolean>(false);
  const [isVerifyMobile, setIsVerifyMobile] = useState<boolean>(false);
  const [otpId, setOtpId] = useState<any>('');
  const [isConfirm, setIsConfirm] = useState<any>(false);
  const [isEdit, setIsEdit] = useState<any>(true);
  const [isUserOtpSent, setIsUserOtpSent] = useState<any>(false);
  const [modalShow, setModalShow] = useState<any>(false);
  const [checkConsent, setCheckConsent] = useState<any>(false);
  const [open, setOpen] = useState<any>(false);
  const [isUserVerify, setUserVerify] = useState<any>(false);
  const [TxtError, setTxtError] = useState<any>('');
  // const [values, setValues] = useState(initialValues);
  // const [countryCode, setCountryCode] = useState<>();
  // const [isError, setIsError] = useState<boolean>(false);
  // const indFormRef = useRef(null);

  const [newNominee, setNewNominee] = useState({
    first_name: '',
    last_name: '',
    age: '',
    relation: '',
    mobile_no: '',
    email: '',
  });
  const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  const nameRegExp = /^[^\d]+$/;
  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .matches(nameRegExp, 'First Name is not valid')
      .required('First Name is required'),
    last_name: Yup.string()
      .matches(nameRegExp, 'Last Name is not valid')
      .required('Last Name is required'),
    age: Yup.number()
      .min(18, 'Must be at least 18 years old')
      .max(99, 'Cannot exceed 99 years')
      .required('Age is required'),
    relation: Yup.string().required('Relation is required'),

    mobile_no: Yup.string()
      .matches(phoneRegExp, 'Mobile number is not valid')
      .min(10)
      .max(10)
      .required('Mobile is required'),
    email: Yup.string().email('Invalid email').required('Email is Required'),
    aadhaar_agree: Yup.boolean().required('Please select consent first'),
    // aadhaar_agree: Yup.bool().oneOf([true], 'Please select consent first'),
  });
  // const nominees = [];

  //     id: 1,
  //     first_name: 'xyz',
  //     last_name: 'pow',
  //     age: '23',
  //     relation: 'daughter',
  //     mobile_no: '9898989898',
  //     email: 'abc@gmail.com',
  //   },
  //   {
  //     id: 2,
  //     first_name: 'xyz',
  //     last_name: 'pow',
  //     age: '23',
  //     relation: 'daughter',
  //     mobile_no: '9898989898',
  //     email: 'abc@gmail.com',
  //   },
  //   {
  //     id: 3,
  //     first_name: 'xyz',
  //     last_name: 'pow',
  //     age: '23',
  //     relation: 'daughter',
  //     mobile_no: '9898989898',
  //     email: 'abc@gmail.com',
  //   },
  // ];

  const cancelEdit = (resetForm) => {
    setIsEdit(true);
    setIsConfirm(false);
    // setCheckConsent(false)
    setIsOtpSent(false);
    setIsVerifyMobile(true);
    setIsMobileVerify(true);
    setNewNominee({
      first_name: '',
      last_name: '',
      age: '',
      relation: '',
      mobile_no: '',
      email: '',
    });
    resetForm();
  };
  // alert cancel function
  const onCancel = () => {
    setOpen(false);
  };

  const onSuccess = () => {
    cancelFunction();
    setOpen(false);
  };

  const cancelFunction = () => {
    setNewNominee({
      first_name: '',
      last_name: '',
      age: '',
      relation: '',
      mobile_no: '',
      email: '',
    });
    setIsAddNominee(false);
    setIsOtpSent(false);
    setOtpValue('');
    setIsMobileVerify(false);
    setIsMobileDisable(false);
    setIsConfirm(false);
  };

  const addNomineeBtn = () => {
    if (nominees.length > 0) {
      return toast.error('You cannot add any more nominees');
    } else if (isAddNominee) {
      return toast.error(
        'Please add existing nominee details, before adding new nominee'
      );
    } else {
      setIsAddNominee(true);
    }
  };

  const addNomineeFunction = async (
    values
    // setFieldError,
    // setFieldValue,
    // resetForm
  ) => {
    try {
      const data = {
        ...values,
        customer_id: customerId,
        is_mobile_verified: isMobileVerify,
        is_customer_mobile_verified: true,
      };
      // console.log('data', data);
      const resp: any = await DashboardHttp.addNominee(data);
      if (resp?.data) {
        // console.log(resp);
        toast.success('Nominee added successfully');
        // const userData: any = await DashboardHttp.getProfile(customerId);
        // setCustomer(userData.data.data.customer);
        // setNominees(userData.data.data.customer.nomineeDetails);
        getNominees();
      }

      setNewNominee({
        first_name: '',
        last_name: '',
        age: '',
        relation: '',
        mobile_no: '',
        email: '',
      });
      // resetForm({ values: '' });
      setIsAddNominee(false);
      setUserVerify(false);
    } catch (err: any) {
      console.log(err);
      toast.error('Something Went Wrong!');
    }
  };

  const updateNomineeFunction = async (values, id) => {
    try {
      const data = {
        ...values,
        id: id,
        customer_id: customerId,
        is_customer_mobile_verified: true,
      };

      if (newNominee?.mobile_no == '') {
        const resp:any = await DashboardHttp.updateNominee(data,user?.userId);
        if (resp?.data) {
          toast.success('Nominee Details Updated Successfully!');
          getNominees();
          setUserVerify(false);
          setIsEdit(true);
        }
        setNewNominee({
          first_name: '',
          last_name: '',
          age: '',
          relation: '',
          mobile_no: '',
          email: '',
        });
        // resetForm({ values: '' });
        setIsAddNominee(false);
      } else if (nominees[0]?.mobileNo !== newNominee?.mobile_no) {
        setIsMobileVerify(false);
        toast.error("Please verify nominee's mobile number");
      } else {
        const resp:any = await DashboardHttp.updateNominee(data,user?.userId);
        if (resp?.data) {
          toast.success('Nominee Details Updated Successfully!');
          getNominees();
          setUserVerify(false);
          setIsEdit(true);
        }

        setNewNominee({
          first_name: '',
          last_name: '',
          age: '',
          relation: '',
          mobile_no: '',
          email: '',
        });
        // resetForm({ values: '' });
        setIsAddNominee(false);
      }
    } catch (err: any) {
      console.log(err);
      toast.error('Something Went Wrong2!');
    }
  };

  const getNominees = async () => {
    try {
      const data = { customer_id: customerId };
      // const resp: any = await DashboardHttp.getNominees(data);
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData?.data) {
        setCustomer(userData?.data?.data?.customer);
        setNominees(userData?.data?.data?.customer?.nomineeDetails);
        setIsVerifyMobile(
          userData?.data?.data?.customer?.nomineeDetails[0]?.isMobileVerified
        );
        // setUserVerify(false);
        // setIsEdit(true);
      }
      // if (customer?.nomineeDetails) {
      //   setNominees(customer.nomineeDetails);
      // }
    } catch (err: any) {
      console.log(err);
      toast.error('Something Went Wrong!');
    }
  };

  const sendOtp = async (e, errors) => {
    // alert(val);
    try {
      e.preventDefault();

      // alert(JSON.stringify(newNominee));

      // setOtpId(resp?.data?.data?.otpId);
      if (Array.isArray(errors) || Object.values(errors).toString() != '') {
        toast.error('All fields are required');
      } else {
        const resp = await DashboardHttp.sendOtp(
          {
            ...newNominee,
            customer_id: customerId,
          },
          user?.userId
        );
       
        if (resp.data.data.status == 'success') {
          setOtpId(resp?.data?.data?.otpId);
          setIsOtpSent(true);
          toast.success('Otp sent successfully!');
        } else {
          toast.error('Something went wrong');
        }
      }
      // else if (JSON.parse(JSON.stringify(errors)).mobile_no !== undefined) {
      //   setIsError(true);
      //   toast.error(JSON.parse(JSON.stringify(errors)).mobile_no);
      // }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const resendMobileOtp = async (
    val,

    setFieldValue
  ) => {
    // alert(val);
    try {
      const data = { otpId: otpId };
      const resp = await DashboardHttp.resendOtp(data);
      if (resp?.data?.data?.status == 'success') {
        toast.success('Otp sent successfully!');
        setOtpValue('');
        // setOtpId('');
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const resendUserMobileOtp = async (
    val,

    setFieldValue
  ) => {
    // alert(val);
    try {
      const data = { otpId: otpId };
      const resp:any = await DashboardHttp.resendCustomerOtp(data,user?.userId);
      if (resp?.data?.data?.status == 'success') {
        toast.success('Otp sent successfully!');
        setOtpValue('');
        // setOtpId('');
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const verifyOtp = async (e, val, setFieldValue) => {
    try {
      e.preventDefault();
      // setSubmitting(false);

      const data = { otp: val?.otp, otpId: otpId };
      const resp: any = await DashboardHttp.verifyOtp(data, user?.userId);
      // alert(val);
      if (resp?.data?.data?.optVerified) {
        setIsMobileVerify(true);
        setIsOtpSent(false);
        setIsMobileDisable(true);
        setOtpValue('');
        setNewNominee({
          first_name: '',
          last_name: '',
          age: '',
          relation: '',
          mobile_no: '',
          email: '',
        });
        toast.success('Mobile number is verified successfully!');
        // getNominees();
      } else {
        toast.error('Something went wrong');
      }
    } catch (err: any) {
      console.log(err?.data?.errors, 'err');
      toast.error(err?.data?.errors[0]?.title);
      setOtpValue('');
      // toast.error('Something went wrong2');
    }
  };

  const sendUserOtp = async () => {
    try {
      // e.preventDefault();

      // alert(JSON.stringify(newNominee));
      const resp: any = await DashboardHttp.sendCustomerOtp({
        mobile_no: user?.mobile?.value,
        user_id: user?.userId,
      });
      // setOtpId(resp?.data?.data?.otpId);
      // if (newNominee?.mobile_no == '') {
      //   toast.error('Mobile number is required');
      // }
      // else if (JSON.parse(JSON.stringify(errors)).mobile_no !== undefined) {
      //   setIsError(true);
      //   toast.error(JSON.parse(JSON.stringify(errors)).mobile_no);
      // }
      if (resp?.data?.data?.status == 'success') {
        setOtpId(resp?.data?.data?.otpId);
        setIsUserOtpSent(true);
        setModalShow(true);
        // setIsOtpSent(true);
        toast.success('Otp sent successfully!');
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };

  const onAddUserVerifySuccess = async (otp, values) => {
    // if (otp == '123456') {
    //   setIsUserOtpSent(false);
    //   setModalShow(false);
    //   addNomineeFunction(values);
    //   setIsConfirm(false);
    //   setUserVerify(true);
    // }
    try {
      setIsLoading(true);
      const data = { otp: otp, otpId: otpId };
      const resp: any = await DashboardHttp.verifyCustomerOtp(
        data,
        user?.userId
      );
      // alert(val);
      if (resp?.data?.data?.optVerified) {
        // setIsMobileVerify(true);
        // setIsOtpSent(false);
        // setIsMobileDisable(true);

        setOtpValue('');
        setNewNominee({
          first_name: '',
          last_name: '',
          age: '',
          relation: '',
          mobile_no: '',
          email: '',
        });
        setIsUserOtpSent(false);
        setModalShow(false);
        addNomineeFunction(values);
        setIsConfirm(false);
        setUserVerify(true);
        setTxtError('');
        setIsLoading(false);

        // toast.success('Mobile number is verified successfully!');
        // getNominees();
      } else {
        toast.error('Something went wrong');
        setIsLoading(false);
      }
    } catch (err: any) {
      console.log(err?.data?.errors, 'err');
      toast.error(err?.data?.errors[0]?.title);
      setTxtError(err?.data?.errors[0]?.title);
      setIsLoading(false);

      setOtpValue('');
      // toast.error('Something went wrong2');
    }
  };
  const onUpdateUserVerifySuccess = async (otp, values, id) => {
    // if (otp == '123456') {
    //   setIsUserOtpSent(false);
    //   setModalShow(false);
    //   updateNomineeFunction(values, id);
    //   setUserVerify(true);
    //   setIsConfirm(false);
    //   setIsEdit(true);

    // }
    try {
      setIsLoading(true);
      const data = { otp: otp, otpId: otpId };
      const resp: any = await DashboardHttp.verifyCustomerOtp(
        data,
        user?.userId
      );
      // alert(val);
      if (resp?.data?.data?.optVerified) {
        // setIsMobileVerify(true);
        // setIsOtpSent(false);
        // setIsMobileDisable(true);

        setOtpValue('');
        setNewNominee({
          first_name: '',
          last_name: '',
          age: '',
          relation: '',
          mobile_no: '',
          email: '',
        });

        setIsUserOtpSent(false);
        setModalShow(false);
        updateNomineeFunction(values, id);
        setUserVerify(true);
        setIsConfirm(false);
        setIsEdit(true);
        setTxtError('');
        setIsLoading(false);
        // toast.success('Mobile number is verified successfully!');
        // getNominees();
      } else {
        toast.error('Something went wrong');
        setIsLoading(false);
      }
    } catch (err: any) {
      console.log(err?.data?.errors, 'err');
      toast.error(err?.data?.errors[0]?.title);
      setTxtError(err?.data?.errors[0]?.title);
      setIsLoading(false);

      setOtpValue('');
      // toast.error('Something went wrong2');
    }
  };
  //   const numb = '91' + val.username;
  //   setNewNominee({
  //     ...newNominee,
  //     mobile_no: val.username,
  //   });
  //   setVal(val);
  //   if (isOtpLogin) {
  //     if (!isOtpSent) {
  //       setFieldTouched('username', true);
  //       if (val?.username && val?.username?.length === 10)
  //         sendMobileOtp(val, setFieldValue);
  //       else {
  //         setFieldError('username', 'Invalid mobile number');
  //       }
  //     } else {
  //       verifyMobileOtp(val);
  //     }
  //   }
  // };
  //   const changeAddress = (e: any) => {
  //     const { name, value } = e.target;
  //     setNewNominee((prevValue) => ({
  //       ...prevValue,
  //       [name]: value,
  //     }));
  //   };

  useEffect(() => {
    getNominees();
  }, []);

  return (
    <>
      <Card>
        <Card.Body className='p-md-5 p-sm-2 pb-0'>
          <div className='d-flex justify-content-between'>
            <Card.Title>Nominee Details</Card.Title>
            {customer?.nomineeDetails?.length < 1 && !isAddNominee && (
              <Button className='btn btn-sm ' onClick={(e) => addNomineeBtn()}>
                + Add Nominee
              </Button>
            )}
          </div>
          {nominees.length > 0 &&
            nominees.map((nom, index) => (
              <Accordion className='mt-4 mb-4' defaultActiveKey='0' key={index}>
                <Accordion.Item eventKey='0'>
                  {/* <Accordion.Header>Nominee</Accordion.Header> */}
                  <Accordion.Body>
                    <Formik
                      initialValues={{
                        first_name: nom?.firstName,
                        last_name: nom?.lastName,
                        age: nom?.age,
                        relation: nom?.relation,
                        mobile_no: nom?.mobileNo,
                        email: nom?.email,
                        aadhaar_agree: false,
                      }}
                      validationSchema={validationSchema}
                      onSubmit={(
                        values,
                        {
                          setFieldError,
                          setFieldTouched,
                          setFieldValue,
                          resetForm,
                        }: FormikHelpers<FormValues>
                      ) => {
                        // updateNomineeFunction(values, nom?.id, resetForm);
                        updateNomineeFunction(values, nom?.id);
                        // resetForm({ values: '' });
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        setFieldError,
                        setFieldTouched,
                        setErrors,
                        setTouched,
                        validateField,
                        resetForm,
                      }) => (
                        <FormikForm>
                          <>
                            {/* <pre>{JSON.stringify(values)}</pre>
                          <pre>{JSON.stringify(errors)}</pre>
                          <pre>{JSON.stringify(touched)}</pre> */}

                            <Card.Body className='p-md-5 p-sm-2 pb-0'>
                              <div>
                                {/* <Card.Title>Nominee Details</Card.Title> */}
                              </div>

                              <Row>
                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>First Name</Form.Label>

                                    <Field
                                      className='form-control form-control1'
                                      type='text'
                                      name='first_name'
                                      maxLength={20}
                                      placeholder='First Name'
                                      onBlur={(e) => {
                                        setFieldTouched('first_name');
                                      }}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          'first_name',
                                          e.target.value
                                        );
                                        setNewNominee({
                                          ...newNominee,
                                          first_name: e.target.value,
                                        });
                                        //   changeAddress(e);
                                      }}
                                      defaultValue={nom?.first_name}
                                      disabled={isEdit}
                                    />
                                    <div className='error text-danger ml-2'>
                                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                                      <ErrorMessage name='first_name'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>Last Name</Form.Label>
                                    {/* <Form.Control
                        disabled
                        type='text'
                        value={account?.displayName || 'NA'}
                      />
                    </Form.Group> */}
                                    <Field
                                      className='form-control form-control1'
                                      type='text'
                                      maxLength={20}
                                      name='last_name'
                                      placeholder='Last Name'
                                      disabled={isEdit}
                                      onBlur={(e) => {
                                        setFieldTouched('last_name');
                                      }}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          'last_name',
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <div className='error text-danger ml-2'>
                                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                                      <ErrorMessage name='last_name'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>Relation</Form.Label>

                                    <Field
                                      as='select'
                                      name='relation'
                                      id='relation'
                                      className='form-control'
                                      onChange={(e) => {
                                        setFieldValue(
                                          'relation',
                                          e.target.value
                                        );

                                        setNewNominee({
                                          ...newNominee,
                                          relation: e.target.value,
                                        });
                                        //   changeAddress(e);
                                      }}
                                      disabled={isEdit}
                                    >
                                      <option value=''>Select an option</option>
                                      <option value='Wife'>Wife</option>
                                      <option value='Husband'>Husband</option>
                                      <option value='Father'>Father</option>
                                      <option value='Mother'>Mother</option>
                                      <option value='Son'>Son</option>
                                      <option value='Daughter'>Daughter</option>
                                      <option value='Brother'>Brother</option>
                                      <option value='Sister'>Sister</option>
                                    </Field>
                                    <div className='error text-danger ml-2'>
                                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                                      <ErrorMessage name='relation'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>Age</Form.Label>

                                    <Field
                                      className='form-control form-control1'
                                      type='number'
                                      min={18}
                                      max={99}
                                      name='age'
                                      placeholder='Age'
                                      onBlur={(e) => {
                                        setFieldTouched('age');
                                      }}
                                      onChange={(e: any) => {
                                        setFieldValue('age', e.target.value);
                                        setNewNominee({
                                          ...newNominee,
                                          age: e.target.value,
                                        });
                                        //   changeAddress(e);
                                      }}
                                      disabled={isEdit}
                                    />
                                    <div className='error text-danger ml-2'>
                                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                                      <ErrorMessage name='age'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>Email</Form.Label>

                                    <Field
                                      className='form-control form-control1'
                                      type='text'
                                      name='email'
                                      placeholder='Email'
                                      onBlur={(e) => {
                                        setFieldTouched('email');
                                      }}
                                      onChange={(e: any) => {
                                        setFieldValue('email', e.target.value);
                                        setNewNominee({
                                          ...newNominee,
                                          email: e.target.value,
                                        });
                                        //   changeAddress(e);
                                      }}
                                      disabled={isEdit}
                                    />
                                    <div className='error text-danger ml-2'>
                                      {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                                      <ErrorMessage name='email'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                </Col>

                                <Col md={6}>
                                  <Form.Group
                                    className='mb-3'
                                    controlId='va-name'
                                  >
                                    <Form.Label>Mobile</Form.Label>

                                    <InputGroup className='mb-2'>
                                      {/* <div
                                      className='input-group-text'
                                      id='basic-addon1'
                                    >
                                      <select
                                        className='form-control country-select'
                                        onChange={(event) =>
                                          setCountryCode(event.target.value)
                                        }
                                        value={countryCode}
                                      >
                                        <option value={'+91'}>+91</option>
                                      </select>
                                    </div> */}
                                      <Field
                                        className='form-control form-control1'
                                        type='number'
                                        name='mobile_no'
                                        placeholder='Mobile'
                                        disabled={isEdit}
                                        // autoFocus='true'
                                        onBlur={(e) => {
                                          setFieldTouched('mobile_no');
                                        }}
                                        onChange={(e: any) => {
                                          setFieldValue(
                                            'mobile_no',
                                            e.target.value
                                          );
                                          setNewNominee({
                                            ...newNominee,
                                            mobile_no: e.target.value,
                                          });
                                          if (
                                            newNominee?.mobile_no !== '' &&
                                            newNominee?.mobile_no !==
                                              nominees[0]?.mobileNo
                                          ) {
                                            setIsVerifyMobile(false);
                                            setIsMobileVerify(false);
                                            setCheckConsent(true);
                                          }

                                          //   changeAddress(e);
                                        }}
                                      />

                                      {/* {!isMobileVerify ? ( */}
                                      {!isVerifyMobile &&
                                        newNominee?.mobile_no !== '' &&
                                        newNominee?.mobile_no !==
                                          nominees[0]?.mobileNo &&
                                        !isOtpSent && (
                                          <div className='input-group-text '>
                                            <button
                                              className='btn btn-verify '
                                              id='button-addon2'
                                              type='button'
                                              style={{
                                                borderRadius: '0 5px 5px 0',
                                              }}
                                              onClick={(e) => {
                                                sendOtp(e, errors);
                                              }}
                                            >
                                              Verify
                                            </button>
                                          </div>
                                        )}
                                      {isVerifyMobile &&
                                        newNominee?.mobile_no == '' &&
                                        nominees[0]?.mobileNo !== '' && (
                                          <div className='input-group-text px-2'>
                                            <img
                                              src={Verified}
                                              width='22px'
                                              height='22px'
                                            />
                                          </div>
                                        )}
                                      {/* {!isMobileVerify &&
                                    newNominee?.mobile_no !== '' &&
                                    newNominee?.mobile_no !==
                                      nominees[0]?.mobileNo ? (
                                      <div className='input-group-text '>
                                        <Spinner animation='border' size='sm' />
                                        <button
                                          className='btn btn-verify'
                                          id='button-addon2'
                                          type='button'
                                          style={{
                                            borderRadius: '0 5px 5px 0',
                                          }}
                                          onClick={(e) => {
                                            sendOtp(e, errors);
                                          }}
                                        >
                                          Request OTP
                                        </button>
                                      </div>
                                    ) : (
                                      <div className='input-group-text px-2'>
                                        <img
                                          src={Verified}
                                          width='22px'
                                          height='22px'
                                        />
                                      </div>
                                    )} */}
                                    </InputGroup>
                                    <div className='error text-danger ml-2'>
                                      <ErrorMessage name='mobile_no'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Form.Group>
                                  {isOtpSent && (
                                    <>
                                      <OtpWithTimer
                                        enableResendTimer
                                        resendInterval={30}
                                        numInputs={6}
                                        otpLabel='Please enter OTP'
                                        otpChangeHandler={(value) => {
                                          setOtpValue(value);
                                          setFieldValue('otp', value);
                                        }}
                                        isCentered
                                        otpValue={otpValue}
                                        resendButtonText='Resend OTP'
                                        ackMessage='OTP has been sent to the mobile number.'
                                        ackMessageType='success'
                                        resendHandler={() =>
                                          resendMobileOtp(values, setFieldValue)
                                        }
                                      ></OtpWithTimer>

                                      <Button
                                        variant='primary'
                                        className='mb-5'
                                        onClick={(e) =>
                                          verifyOtp(e, values, setFieldValue)
                                        }
                                      >
                                        Verify
                                      </Button>
                                    </>
                                  )}
                                </Col>
                                {!isEdit && (
                                  <>
                                    <Col md={12}>
                                      <div className='form-group mb-2'>
                                        <label className='form-label'>
                                          <Field
                                            disabled={
                                              Array.isArray(errors) ||
                                              Object.values(
                                                errors
                                              ).toString() != '' ||
                                              (newNominee?.mobile_no !== '' &&
                                                newNominee?.mobile_no !==
                                                  nominees[0]?.mobileNo)
                                            }
                                            type='checkbox'
                                            placeholder=''
                                            name='aadhaar_agree'
                                            // disabled={isOtpSent}
                                            className='mx-1'
                                            checked={isConfirm}
                                            onChange={(e) => {
                                              setIsConfirm(e.target.checked);
                                              setFieldValue(
                                                'aadhaar_agree',
                                                e.target.checked
                                              );
                                              if (e.target.checked) {
                                                setFieldError(
                                                  'aadhaar_agree',
                                                  ''
                                                );
                                              }
                                            }}
                                          />
                                          I confirm the nominee details provided
                                          above are correct and should be put in
                                          records.
                                        </label>
                                      </div>
                                      <div className='error text-danger ml-2'>
                                        <ErrorMessage name='aadhaar_agree'>
                                          {(msg) => (
                                            <span className='error'>{msg}</span>
                                          )}
                                        </ErrorMessage>
                                      </div>
                                    </Col>
                                    <div className='text-center'>
                                      {isConfirm && (
                                        <Button
                                          disabled={
                                            Array.isArray(errors) ||
                                            Object.values(errors).toString() !=
                                              '' ||
                                            (newNominee?.mobile_no !== '' &&
                                              newNominee?.mobile_no !==
                                                nominees[0]?.mobileNo)
                                          }
                                          onClick={() => sendUserOtp()}
                                          className=' w-30 '
                                        >
                                          Confirm
                                        </Button>
                                      )}
                                      {!isEdit ? (
                                        <>
                                          {/* {isUserVerify ? (
                                    <Button variant='primary' type='submit'>
                                      Update
                                    </Button>
                                  ) : null} */}
                                          <Button
                                            variant='secondary'
                                            className=' m-3'
                                            onClick={() => {
                                              cancelEdit(resetForm);
                                            }}
                                            // className="text-center"
                                          >
                                            Cancel
                                          </Button>
                                        </>
                                      ) : (
                                        <Button
                                          variant='primary'
                                          onClick={() => setIsEdit(false)}
                                        >
                                          Edit
                                        </Button>
                                      )}
                                    </div>
                                  </>
                                )}

                                <Col md={6}>
                                  {isUserOtpSent && (
                                    <OtpModal
                                      show={modalShow}
                                      handleClose={() => setModalShow(false)}
                                      title={
                                        'OTP is sent to your registered mobile number'
                                      }
                                      onSuccess={(otp) =>
                                        onUpdateUserVerifySuccess(
                                          otp,
                                          values,
                                          nom?.id
                                        )
                                      }
                                      resend={() =>
                                        resendUserMobileOtp(
                                          values,
                                          setFieldValue
                                        )
                                      }
                                      txtError={TxtError}
                                      loading={isLoading}
                                    />
                                  )}
                                </Col>
                              </Row>

                              {!isEdit ? (
                                <>
                                  {/* {isUserVerify ? (
                                    <Button variant='primary' type='submit'>
                                      Update
                                    </Button>
                                  ) : null} */}
                                  {/* <Button
                                    variant='secondary'
                                    onClick={() => {
                                      cancelEdit(resetForm);
                                    }}
                                    className="text-center"
                                  >
                                    Cancel
                                  </Button> */}
                                </>
                              ) : (
                                <Button
                                  variant='primary'
                                  onClick={() => setIsEdit(false)}
                                >
                                  Edit
                                </Button>
                              )}
                            </Card.Body>
                          </>
                        </FormikForm>
                      )}
                    </Formik>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ))}
          {isAddNominee && (
            <Accordion className='mt-4 mb-4' defaultActiveKey='4'>
              <Accordion.Item eventKey='4'>
                {/* <Accordion.Header>Nominee</Accordion.Header> */}
                <Accordion.Body>
                  <Formik
                    initialValues={{
                      first_name: '',
                      last_name: '',
                      age: '',
                      relation: '',
                      mobile_no: '',
                      email: '',
                      aadhaar_agree: false,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(
                      values,
                      {
                        setFieldError,
                        setFieldTouched,
                        setFieldValue,
                        resetForm,
                      }: FormikHelpers<FormValues>
                    ) => {
                      addNomineeFunction(
                        values
                        // setFieldError,
                        // setFieldValue,
                        // resetForm
                      );
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      setFieldError,
                      setFieldTouched,
                      setErrors,
                      setTouched,
                      validateField,
                    }) => (
                      <FormikForm>
                        <>
                          {/* <pre>{JSON.stringify(values)}</pre>
                        <pre>{JSON.stringify(errors)}</pre>
                        <pre>{JSON.stringify(touched)}</pre> */}

                          <Card.Body className='p-md-5 p-sm-2 pb-0'>
                            <div>
                              {/* <Card.Title>Nominee Details</Card.Title> */}
                            </div>

                            <Row>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>First Name</Form.Label>

                                  <Field
                                    className='form-control form-control1'
                                    type='text'
                                    name='first_name'
                                    maxLength={20}
                                    placeholder='First Name'
                                    onBlur={(e) => {
                                      setFieldTouched('first_name');
                                    }}
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        'first_name',
                                        e.target.value
                                      );
                                      setNewNominee({
                                        ...newNominee,
                                        first_name: e.target.value,
                                      });
                                      // changeAddress(e);
                                    }}
                                  />
                                  <div className='error text-danger ml-2'>
                                    <ErrorMessage name='first_name'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>Last Name</Form.Label>

                                  <Field
                                    className='form-control form-control1'
                                    type='text'
                                    maxLength={20}
                                    name='last_name'
                                    placeholder='Last Name'
                                    onBlur={(e) => {
                                      setFieldTouched('last_name');
                                    }}
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        'last_name',
                                        e.target.value
                                      );
                                      setNewNominee({
                                        ...newNominee,
                                        last_name: e.target.value,
                                      });
                                      // changeAddress(e);
                                    }}
                                    disabled={
                                      values?.first_name == '' ? true : false
                                    }
                                  />
                                  <div className='error text-danger ml-2'>
                                    {/* {errors.address1 && touched.address1 && (
                      <small id='my-helper-text '>{errors.address1}</small>
                    )} */}
                                    <ErrorMessage name='last_name'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>Relation</Form.Label>

                                  <Field
                                    as='select'
                                    name='relation'
                                    id='relation'
                                    className='form-control'
                                    onChange={(e) => {
                                      setFieldValue('relation', e.target.value);
                                      setNewNominee({
                                        ...newNominee,
                                        relation: e.target.value,
                                      });
                                    }}
                                    disabled={
                                      values?.last_name == '' ? true : false
                                    }
                                  >
                                    <option value=''>Select an option</option>
                                    <option value='Wife'>Wife</option>
                                    <option value='Husband'>Husband</option>
                                    <option value='Father'>Father</option>
                                    <option value='Mother'>Mother</option>
                                    <option value='Son'>Son</option>
                                    <option value='Daughter'>Daughter</option>
                                    <option value='Brother'>Brother</option>
                                    <option value='Sister'>Sister</option>
                                  </Field>
                                  <div className='error text-danger ml-2'>
                                    {/* {errors.address1 && touched.address1 && (
                      <small id='my-helper-text '>{errors.address1}</small>
                    )} */}
                                    <ErrorMessage name='relation'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>Age</Form.Label>

                                  <Field
                                    className='form-control form-control1'
                                    type='number'
                                    min={18}
                                    max={99}
                                    name='age'
                                    placeholder='Age'
                                    onBlur={(e) => {
                                      setFieldTouched('age');
                                    }}
                                    onChange={(e: any) => {
                                      setFieldValue('age', e.target.value);
                                      setNewNominee({
                                        ...newNominee,
                                        age: e.target.value,
                                      });
                                      // changeAddress(e);
                                    }}
                                    disabled={
                                      values?.relation == '' ? true : false
                                    }
                                  />
                                  <div className='error text-danger ml-2'>
                                    {/* {errors.address1 && touched.address1 && (
                      <small id='my-helper-text '>{errors.address1}</small>
                    )} */}
                                    <ErrorMessage name='age'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>Email</Form.Label>

                                  <Field
                                    className='form-control form-control1'
                                    type='text'
                                    name='email'
                                    placeholder='Email'
                                    onBlur={(e) => {
                                      setFieldTouched('email');
                                    }}
                                    onChange={(e: any) => {
                                      setFieldValue('email', e.target.value);
                                      setNewNominee({
                                        ...newNominee,
                                        email: e.target.value,
                                      });
                                      // changeAddress(e);
                                    }}
                                    disabled={values?.age == '' ? true : false}
                                  />
                                  <div className='error text-danger ml-2'>
                                    {/* {errors.address1 && touched.address1 && (
                      <small id='my-helper-text '>{errors.address1}</small>
                    )} */}
                                    <ErrorMessage name='email'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className='mb-3'
                                  controlId='va-name'
                                >
                                  <Form.Label>Mobile</Form.Label>

                                  <InputGroup className='mb-2'>
                                    <Field
                                      className='form-control form-control1'
                                      type='number'
                                      name='mobile_no'
                                      placeholder='Mobile'
                                      // autoFocus={true}
                                      onBlur={(e) => {
                                        setFieldTouched('mobile_no');
                                      }}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          'mobile_no',
                                          e.target.value
                                        );
                                        setNewNominee({
                                          ...newNominee,
                                          mobile_no: e.target.value,
                                        });
                                        if (
                                          newNominee?.mobile_no !== '' &&
                                          newNominee?.mobile_no !==
                                            nominees[0]?.mobileNo
                                        ) {
                                          setIsVerifyMobile(false);
                                          setIsMobileVerify(false);
                                        }
                                        //   changeAddress(e);
                                      }}
                                      // disabled={isMobileDisable}
                                      disabled={
                                        values?.email == ''
                                          ? true
                                          : isMobileDisable
                                      }
                                    />

                                    {!isMobileVerify &&
                                      !isOtpSent &&
                                      newNominee?.mobile_no !== '' && (
                                        <div className='input-group-text '>
                                          {/* <Spinner animation='border' size='sm' /> */}
                                          <button
                                            className='btn btn-verify'
                                            id='button-addon2'
                                            type='button'
                                            style={{
                                              borderRadius: '0 5px 5px 0',
                                            }}
                                            onClick={(e) => {
                                              sendOtp(e, errors);
                                            }}
                                          >
                                            Verify
                                          </button>
                                        </div>
                                      )}
                                    {isMobileVerify && (
                                      <div className='input-group-text px-2'>
                                        <img
                                          src={Verified}
                                          width='22px'
                                          height='22px'
                                        />
                                      </div>
                                    )}

                                    {/* {!isMobileVerify ? (
                                    <div className='input-group-text '>
                                      <Spinner animation='border' size='sm' />
                                      <button
                                        className='btn btn-verify'
                                        id='button-addon2'
                                        type='button'
                                        style={{
                                          borderRadius: '0 5px 5px 0',
                                        }}
                                        onClick={(e) => {
                                          sendOtp(e, errors);
                                        }}
                                      >
                                        Request OTP
                                      </button>
                                    </div>
                                  ) : (
                                    <div className='input-group-text px-2'>
                                      <img
                                        src={Verified}
                                        width='22px'
                                        height='22px'
                                      />
                                    </div>
                                  )} */}
                                  </InputGroup>
                                  <div className='error text-danger ml-2'>
                                    <ErrorMessage name='mobile_no'>
                                      {(msg) => (
                                        <span className='error'>{msg}</span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </Form.Group>
                                {isOtpSent && (
                                  <>
                                    <OtpWithTimer
                                      enableResendTimer
                                      resendInterval={30}
                                      numInputs={6}
                                      otpLabel='Please enter OTP'
                                      otpChangeHandler={(value) => {
                                        setOtpValue(value);
                                        setFieldValue('otp', value);
                                        // if (value?.length === 6)
                                        // signIn(
                                        //   {
                                        //     ...values,
                                        //     otp: value,
                                        //   },
                                        //   setFieldTouched,
                                        //   setFieldError,
                                        //   setFieldValue
                                        // );
                                      }}
                                      isCentered
                                      otpValue={otpValue}
                                      resendButtonText='Resend OTP'
                                      ackMessage='OTP has been sent to the mobile number.'
                                      ackMessageType='success'
                                      resendHandler={() =>
                                        resendMobileOtp(values, setFieldValue)
                                      }
                                    ></OtpWithTimer>

                                    <Button
                                      variant='primary'
                                      onClick={(e) =>
                                        verifyOtp(e, values, setFieldValue)
                                      }
                                    >
                                      Verify
                                    </Button>
                                  </>
                                )}
                                <div className='form-group mb-2'>
                                  {/* <label className='form-label'>Mobile</label> */}
                                  <div className='input-group mb-3'>
                                    {/* <div
                                          className='input-group-text'
                                          id='basic-addon1'
                                        >
                                          <select
                                            className='form-control country-select'
                                            onChange={(event) =>
                                              setCountryCode(event.target.value)
                                            }
                                            value={countryCode}
                                          >
                                            <option value={'+91'}>+91</option>
                                          </select>
                                        </div> */}
                                    {/* <Field
                                          type='text'
                                          placeholder=''
                                          name='username'
                                          className='form-control'
                                          disabled={isOtpLogin && isOtpSent}
                                          onChange={(e) => {
                                            if (
                                              e.target.value.length > 10 ||
                                              /[^0-9]/.test(e.target.value)
                                            )
                                              return;
                                            setFieldValue(
                                              'username',
                                              e.target.value
                                            );
                                          }}
                                        /> */}
                                    {/* <InputGroup className='mb-2'>
                                    <Form.Control
                                      type='text'
                                      placeholder=''
                                      name='mobile_no'
                                      className='form-control'
                                      disabled={isOtpLogin && isOtpSent}
                                      onChange={(e) => {
                                        if (
                                          e.target.value.length > 10 ||
                                          /[^0-9]/.test(e.target.value)
                                        )
                                          return;
                                        setFieldValue(
                                          'mobile_no',
                                          e.target.value
                                        );
                                        setNewNominee({
                                          ...newNominee,
                                          mobile_no: e.target.value,
                                        });
                                      }}
                                    />

                                    {!isMobileVerify ? (
                                      <div className='input-group-text px-2'>
                                        <Spinner animation='border' size='sm' />
                                      </div>
                                    ) : (
                                      <div className='input-group-text px-2'>
                                        <img
                                          src={Verified}
                                          width='22px'
                                          height='22px'
                                        />
                                      </div>
                                    )}
                                  </InputGroup> */}
                                    {/* {isError && (
                               
                                    <div className='error text-danger ml-2'>
                                      <ErrorMessage name='mobile_no'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  )} */}
                                  </div>
                                  <Field
                                    type='text'
                                    placeholder=''
                                    name='isOtp'
                                    className='form-control'
                                    hidden
                                  />
                                </div>
                              </Col>
                              {isMobileVerify && (
                                <>
                                  <Col md={12}>
                                    <div className='form-group mb-2'>
                                      <label className='form-label'>
                                        <Field
                                          disabled={
                                            Array.isArray(errors) ||
                                            Object.values(errors).toString() !=
                                              ''
                                          }
                                          type='checkbox'
                                          placeholder=''
                                          name='aadhaar_agree'
                                          // disabled={isOtpSent}
                                          className='mx-1'
                                          onChange={(e) => {
                                            setIsConfirm(e.target.checked);
                                            setFieldValue(
                                              'aadhaar_agree',
                                              e.target.checked
                                            );
                                            if (e.target.checked) {
                                              setFieldError(
                                                'aadhaar_agree',
                                                ''
                                              );
                                            }
                                          }}
                                        />
                                        I confirm the nominee details provided
                                        above are correct and should be put in
                                        records.
                                      </label>
                                    </div>
                                    <div className='error text-danger ml-2'>
                                      <ErrorMessage name='aadhaar_agree'>
                                        {(msg) => (
                                          <span className='error'>{msg}</span>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </Col>
                                  <div className='text-center'>
                                    {isConfirm && (
                                      <>
                                        <Button
                                          disabled={
                                            Array.isArray(errors) ||
                                            Object.values(errors).toString() !=
                                              '' ||
                                            (newNominee?.mobile_no !== '' &&
                                              newNominee?.mobile_no !==
                                                nominees[0]?.mobileNo)
                                          }
                                          onClick={() => sendUserOtp()}
                                          className=' w-30 '
                                        >
                                          Confirm
                                        </Button>
                                        <Button
                                          variant='secondary'
                                          className='m-2'
                                          onClick={() => setOpen(true)}
                                        >
                                          Cancel
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                  {/* {isConfirm && (
                                    <Button
                                      disabled={
                                        Array.isArray(errors) ||
                                        Object.values(errors).toString() !=
                                          '' ||
                                        (newNominee?.mobile_no !== '' &&
                                          newNominee?.mobile_no !==
                                            nominees[0]?.mobileNo)
                                      }
                                      onClick={() => sendUserOtp()}
                                    >
                                      Confirmmm
                                    </Button>
                                  )} */}
                                </>
                              )}
                              <Col md={6}>
                                {isUserOtpSent && (
                                  // <>
                                  //   <OtpWithTimer
                                  //     enableResendTimer
                                  //     resendInterval={30}
                                  //     numInputs={6}
                                  //     otpLabel='Please enter OTP'
                                  //     otpChangeHandler={(value) => {
                                  //       setOtpValue(value);
                                  //       setFieldValue('otp', value);
                                  //     }}
                                  //     isCentered
                                  //     otpValue={otpValue}
                                  //     resendButtonText='Resend OTP'
                                  //     ackMessage='OTP has been sent to your registered mobile number.'
                                  //     ackMessageType='success'
                                  //     resendHandler={() =>
                                  //       resendMobileOtp(values, setFieldValue)
                                  //     }
                                  //   ></OtpWithTimer>

                                  //   <Button
                                  //     variant='primary'
                                  //     onClick={(e) =>
                                  //       verifyOtp(e, values, setFieldValue)
                                  //     }
                                  //   >
                                  //     Verify
                                  //   </Button>
                                  // </>

                                  <OtpModal
                                    show={modalShow}
                                    handleClose={() => setModalShow(false)}
                                    title={
                                      'OTP is sent to your registered mobile number'
                                    }
                                    onSuccess={(otp) =>
                                      onAddUserVerifySuccess(otp, values)
                                    }
                                    resend={() =>
                                      resendUserMobileOtp(values, setFieldValue)
                                    }
                                    txtError={TxtError}
                                    loading={isLoading}
                                  />
                                )}
                              </Col>
                            </Row>

                            {/* {isUserVerify && (
                              <Button variant='primary' type='submit'>
                                Add
                              </Button>
                            )} */}
                            {!isConfirm && (
                              <Button
                                variant='secondary'
                                className='m-2'
                                onClick={() => setOpen(true)}
                              >
                                Cancel
                              </Button>
                            )}
                          </Card.Body>
                        </>
                      </FormikForm>
                    )}
                  </Formik>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          )}
        </Card.Body>
      </Card>
      <Alert
        open={open}
        message='Are you sure you want to close? All changes will be discarded'
        onSuccess={onSuccess}
        onCancel={onCancel}
      />
    </>
  );
};

export default Nomination;
function setFieldTouched(arg0: string, arg1: boolean) {
  throw new Error('Function not implemented.');
}
